import Cities from './cities';
export default function Content({ handleClick, setSeverity, setMessage }) {
    return (
        <>
            <Cities />
        </>
    );
};